import React, {useContext} from "react"
import Typography from "../../reusable/Typography/Typography"
import QuizzContextProvider from "../../../provider/QuizzContextProvider"
import SuggestionQuiz from "./SuggestionQuiz"
import {useTranslation} from "next-i18next"
import LayoutContext from "../../../context/LayoutContext"

function SuggestionQuizHeader() {
	const {t} = useTranslation()
	const {isMobile} = useContext(LayoutContext)

	return (
		<header
			className="suggestion-quiz-container ">
			<div
				className="d-flex quiz-success-container align-items-md-center  justify-content-start flex-column gap-2 ">
				<Typography className="text-md-center text-left"
					variant="bodySmBlack"
					style={{fontSize: isMobile ? "28px" : "52px", lineHeight: isMobile ? "36px" : "64px", color: "#fff"}}>{t("suggestion-quiz-title")}</Typography>
				<Typography className="text-md-center text-left"
					variant="bodyLg"
					style={{fontSize: "14px", lineHeight: "20px", color: "#fff"}}>{t("suggestion-quiz-description")}</Typography>
			</div>
			<QuizzContextProvider>
				<SuggestionQuiz />
			</QuizzContextProvider>
		</header>
	)
}

export default SuggestionQuizHeader
